// Shared brand tokens -- keep in sync with AtlasDesignSystem's src/tokens/index.css.
// Hex values here are the documented QR brand equivalents of Atlas's OKLCH tokens,
// used instead of raw oklch() because AntD's internal shade-generation algorithm
// (hover/active tint math) doesn't understand OKLCH strings. Plain CSS elsewhere
// (the header bar, the diamond mark) can use oklch() directly with no such risk.

export const colors = {
  blue: '#4974FF',
  midnight: '#173073',
  teal: '#00B6D3',
  mustard: '#D0AA46',
  yellow: '#FFDE69',
  neutral1: '#fcfcfd',
  neutral2: '#f8f8fa',
  neutral6: '#e3e3e8',
  neutral9: '#8d8d9c',
  neutral11: '#6a6a78',
  neutral12: '#26262f'
};

export const fontSans = '"GT Good Sans", Arial, system-ui, sans-serif';
export const fontSerif = '"Playfair Display", "Times New Roman", Times, serif';

export const antdTheme = {
  token: {
    colorPrimary: colors.blue,
    borderRadius: 4,
    fontFamily: fontSans
  }
};

// Tag/status colors, centralized so components don't hardcode hex.
export const actionColors = {
  create: colors.blue,
  edit: colors.teal,
  delete: colors.midnight,
  enable: colors.blue,
  disable: colors.neutral9
};
